import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import backend from 'utils/backend';

const SkillSync = (props) => {
  const {
    user,
    skills,
    skillsLoadSkills,
  } = props;

  React.useEffect(() => {
    if (!user?.userRn) {
      return;
    }
    if (skills.lastLoadTime) {
      return;
    }
    const loadSkills = async () => {
      try {
        const skills = await backend.skills.getSkills();
        skillsLoadSkills(skills.list);
      } catch (error) {
        console.error('Failed to sync skills', error);
      }
    };
    loadSkills();
  }, [user, skills]);

  return null;
};

SkillSync.propTypes = {
  user: PropTypes.object,
  skills: PropTypes.array.isRequired,
  skillsLoadSkills: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  skills: state.skills,
});

export default connect(mapStateToProps, dispatch)(React.memo(SkillSync));
